var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{attrs:{"color":"#BDBDBD","size":_vm.size}},[_c('span',{staticClass:"white--text",class:{ headline: !_vm.size || _vm.size > 30 }},[_vm._v(" "+_vm._s(_vm.avatarText)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }